var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DScrollArea',{ref:"scrollArea",style:('height: ' + _vm.height + 'px;'),attrs:{"noScrolling":_vm.noScrolling,"behavior":_vm.behavior,"storePath":_vm.storePath}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }